import React from 'react'
import _ from 'underscore'
import { Input as UIInput } from '@/components/ui/input'
import { cn } from '@/lib/utils'

class DebouncedInput extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      value: this.props.value || ''
    }
  }

  inputRef = React.createRef()

  componentDidMount() {
    this.debouncedUpdate = _.debounce(this.update, 1000)
  }

  componentWillReceiveProps(nextProps) {
    const dirty = nextProps.value !== this.state.value
    const value = nextProps.value

    if ((dirty !== this.state.dirty) || (value !== this.state.value)) {
      this.setState({dirty: false, value: nextProps.value})
    }
  }

  onChange = () => {
    const value = this.inputRef.current.value

    if (this.props.regex) {
      if (this.props.regex.test(value)) {
        this.setState({value: value, dirty: true})
        this.debouncedUpdate(value)
      }
    }
    else {
      this.setState({value: value, dirty: true})
      this.debouncedUpdate(value)
    }
  }

  update = (value) => {
    this.props.onChange(value)
  }

  render() {
    return (
      <UIInput
        ref={this.inputRef}
        type={this.props.type || 'text'}
        className={cn(this.state.dirty && 'bg-[#ffffe6]!')}
        placeholder={this.props.placeholder}
        value={this.state.value}
        onChange={this.onChange}
      />
    )
  }
}

export default DebouncedInput
